import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

export interface AuthenticationProps {
  switchMode: (mode: 'login' | 'signup' | 'reset') => void;
}

const AuthenticationRegister: React.FC<AuthenticationProps> = ({ switchMode }) => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const { register } = useAuth();

  // State to handle validation errors
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  // Simple validation function
  const validateForm = () => {
    let valid = true;
    const errorForm = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
    };

    // Validate firstName
    if (!form.firstName) {
      errorForm.firstName = 'First name is required';
      valid = false;
    }

    if (form.password !== form.confirmPassword) {
      errorForm.confirmPassword = 'Passwords do not match';
      valid = false;
    }
    // Set errors state
    setErrors(errorForm);
    return valid;
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (validateForm()) {
      register(
        form.email,
        `${form.firstName} ${form.lastName}`,
        form.password,
        () => { window.location.href = '/home'; },
        (failedError) => { setError(failedError); },
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {
        error !== '' && (
          <div
            className="p-4 mb-4 text-sm text-red-800 border border-red-500 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
            role="alert"
          >
            <span className="font-medium">Registration Failed! </span>
            {error}
          </div>
        )
      }

      <div className="grid gap-6 mb-6 md:grid-cols-2">
        <div>
          <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-white">
            First name
            <input
              type="text"
              className="input input-bordered block w-full mt-1 text-black dark:text-white"
              id="firstName"
              name="firstName"
              required
              placeholder="First Name"
              value={form.firstName}
              onChange={handleInputChange}
            />
            {errors.firstName && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.firstName}</p>}
          </label>
        </div>
        <div>
          <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-white">
            Last name
            <input
              className="input input-bordered block w-full mt-1 text-black dark:text-white"
              type="name"
              id="lastName"
              name="lastName"
              required
              placeholder="Last Name"
              value={form.lastName}
              onChange={handleInputChange}
            />
            {errors.lastName && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.lastName}</p>}
          </label>

        </div>
      </div>
      <div className="mb-6">
        <label
          htmlFor="email"
          className="block mb-2 text-sm font-medium text-white"
        >
          Email address
          <input
            className="input input-bordered block w-full mt-1 text-black dark:text-white"
            type="email"
            id="email"
            name="email"
            required
            placeholder="mail@gmail.com"
            value={form.email}
            onChange={handleInputChange}
          />
          {errors.email && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.email}</p>}
        </label>
      </div>
      <div className="mb-6">
        <label htmlFor="password" className="block mb-2 text-sm font-medium text-white">
          Password
          <input
            className="input input-bordered block w-full mt-1 text-black dark:text-white"
            type="password"
            id="password"
            placeholder="•••••••••"
            name="password"
            value={form.password}
            onChange={handleInputChange}
            required
          />
          {errors.password && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.password}</p>}
        </label>
      </div>
      <div className="mb-6">
        <label htmlFor="confirm_password" className="block mb-2 text-sm font-medium text-white">
          Confirm password
          <input
            type="password"
            id="confirmPassword"
            className="input input-bordered block w-full mt-1 text-black dark:text-white"
            placeholder="•••••••••"
            required
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleInputChange}
          />
        </label>
        {errors.confirmPassword && <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.confirmPassword}</p>}
      </div>
      <div className="flex items-start mb-6">
        <label htmlFor="remember" className="ms-2 text-sm font-medium text-white">
          <div className="flex items-center h-5">
            <input id="remember" type="checkbox" value="" className="checkbox" required />
          </div>
          I agree with the
          <a href="/" className="text-blue-600 hover:underline dark:text-blue-500"> terms and conditions</a>
          .
        </label>
      </div>
      <div className="flex gap-2 ">
        <button
          type="submit"
          className="btn btn-primary"
        >
          Submit
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => { switchMode('login'); }}
        >
          Switch to Login
        </button>
        <button
          type="button"
          className="text-white underline font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
          onClick={() => { switchMode('reset'); }}
        >
          Forgot Password?
        </button>
      </div>
    </form>
  );
};

export default AuthenticationRegister;
